import type { ReactNode } from 'react';
import { srOnly } from '../../styles/layout.css';

export interface VisuallyHiddenProps {
  /** Content to be hidden visually but accessible to screen readers */
  children: ReactNode;
  /** HTML element to render (default: 'span') */
  as?: 'span' | 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

/**
 * VisuallyHidden - 시각적으로 숨겨진 요소
 *
 * 스크린 리더 사용자에게는 보이지만 화면에는 표시되지 않는 컴포넌트입니다.
 * 접근성을 위한 헤딩, 레이블 등에 사용합니다.
 *
 * @example
 * ```tsx
 * <VisuallyHidden as="h1">페이지 제목</VisuallyHidden>
 * ```
 */
export function VisuallyHidden({ children, as: Component = 'span' }: VisuallyHiddenProps) {
  return <Component className={srOnly}>{children}</Component>;
}
